<script>
import { Cell, Popup, Area } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'area-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-area': Area
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label:String,
        areaList:Object,
        all:String,
        allArea: String,
        selectedAreaLabel: String,
        selectedAreaCode: String
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            selectedAreaItem: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
        areaLabel() {
            let selectedLabel = ''
            if (this.selectedAreaItem) {
                selectedLabel = this.selectedAreaItem.map((item) => item ? item.name : '').join(' ')
            }
            else if (this.selectedAreaLabel) {
                selectedLabel = this.selectedAreaLabel
            }
            return selectedLabel
        },
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onItemClick() {
            console.log('onItemClick')
            this.showPopup = true
        },
        onCancelBtnClick() {
            console.log('onCancelBtnClick')
            this.showPopup = false
        },
        onConfirmBtnClick(data) {
            console.log('onConfirmBtnClick', data)
            if (data[1] == null && data[2] == null) {
                data[0].name = this.allArea
            }
            this.selectedAreaItem = data
            let selectedCode = '000000'
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    let item = data[i]
                    if (item && item.code) {
                        selectedCode = item.code
                    }
                }
            }
            
            if (selectedCode) {
                const selectedLabel = this.selectedAreaItem.map((item) => item ? item.name : '').join(' ');
                this.$emit('change-data', {
                    code: selectedCode,
                    label: selectedLabel.trim()
                })
            }
            
            this.showPopup = false
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="area-selector van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :title="label"
            is-link
            center
            :value="areaLabel"
            @click="onItemClick"
        />
        <van-popup 
            v-model="showPopup"
            position="bottom"
        >
            <van-area
                :title="label"
                :area-list="areaList"
                :columns-placeholder="[all, all, all]"
                :value="selectedAreaCode"
                @cancel="onCancelBtnClick"
                @confirm="onConfirmBtnClick"
            />
        </van-popup>
    </div>
</template>